import React from 'react';
import { ReactComponent as SeatIconSvg } from './seat-svgrepo-com.svg';
import { ReactComponent as DoorIconSvg } from './door.svg';
import { ReactComponent as FridgeIconSvg } from './fridge-svgrepo-com.svg';
import { ReactComponent as ToiletSvg } from './toilet.svg';

export const SeatIcon = (props: React.SVGProps<any>) => <SeatIconSvg {...props} />;
export const BusDoorIcon = (props: React.SVGProps<any>) => <DoorIconSvg {...props} />;
export const FridgeIcon = (props: React.SVGProps<any>) => <FridgeIconSvg {...props} />;

export const BusTopBg = (props: React.ImgHTMLAttributes<any>) => <img src={require('./bus-top-bg.png')} alt="bus" {...props} />;
export const BusBottomBg = (props: React.ImgHTMLAttributes<any>) => <img src={require('./bus-bottom-bg.png')} alt="bus" {...props} />;
export const BusMiddleBg = (props: React.ImgHTMLAttributes<any>) => <img src={require('./bus-middle-bg.png')} alt="bus" {...props} />;

export const ToiletIcon = (props: React.SVGProps<any>) => <ToiletSvg {...props} />;
